/* eslint-disable func-names */

/* global document, NodeList */
/* eslint no-use-before-define: ["error", { "functions": false }] */
import navToggle from './nav-toggle';
import navOverFlow from './nav-overflow';
import customHeaderSchedulerService from './ui-sitewide-header-scheduler-service';
/**
 * Initialises the component when passed an element
 *
 * @param {HTMLNode} rootElement The component dom node
 */
export default function(rootElement) {
  if (!NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }

  if (!rootElement) {
    return;
  }

  // get all elements with a nav-trigger role and add the nav click function
  const navBody = rootElement.querySelector('[data-role="nav-body"]');
  const overflowNav = rootElement.querySelector('[data-role="overflow-navigation"]');
  const mainNavItems = rootElement.querySelectorAll('[data-role="main-nav-item"]');
  const overflowNavButton = rootElement.querySelector('[data-role="overflow-navigation-button"]');

  // add listener for sub menu activity
  rootElement.addEventListener('click', (event) => {
    let target = event.target;

    // toggle nav based on the state of the expanded attribute
    while (target && target.parentNode) {
      if (target.getAttribute('data-role') === 'nav-trigger') {
        event.preventDefault();
        hideSubnavs(target);
        navToggle(rootElement, target);
        break;
      }

      target = target.parentNode;
    }
  });

  // hide sub navs when the body outside of the nav is clicked
  document.body.addEventListener('click', (event) => {
    const target = event.target;
    // close navs when body is clicked outside of a nav scope
    if (!matchesSelector(target, `[data-role="nav-scope"] ${target.tagName}`)) {
      hideSubnavs(target);
    }
  });

  // hide main mobile menu when escape key is pressed
  document.addEventListener('keydown', (e) => {
    if (e.keyCode === 27) {
      navToggle(rootElement, rootElement.querySelector('[data-role="nav-trigger"][aria-expanded="true"]'), true);
    }
  });

  function matchesSelector(el, selector) {
    let match = false;
    const m = (el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector);
    if (m) {
      match = m.call(el, selector);
    }

    return match;
  }

  function hideSubnavs(target) {
    const navs = rootElement.querySelectorAll('[data-role="nav-trigger"][aria-expanded="true"]');
    navs.forEach((item) => {
      if (item !== target) {
        navToggle(rootElement, item, false);
      }
    });
  }

  navBody.addEventListener('touchstart', () => {
    const scrollTop = navBody.scrollTop;

    if (scrollTop === 0) {
      navBody.scrollTop = 1;
    } else {
      navBody.scrollTop = (scrollTop - 1);
    }
  });

  if (overflowNav) {
    navOverFlow(overflowNav, overflowNavButton, mainNavItems);
  }

  const headerStartTime = rootElement.getAttribute('data-scheduled-header-start');
  const headerEndTime = rootElement.getAttribute('data-scheduled-header-end');
  const timedHeaderClass = rootElement.getAttribute('data-scheduled-header-custom-class');
  if (headerStartTime && headerEndTime && timedHeaderClass) {
    customHeaderSchedulerService(headerStartTime, headerEndTime, timedHeaderClass, rootElement);
  }
}
